"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var inversify_1 = require("inversify");
var EditorTypes_1 = require("./EditorTypes");
var LinkWidget_1 = __importDefault(require("./Widgets/LinkWidget/LinkWidget"));
var TokenWidget_1 = require("Project/QwilrEditor/Widgets/TokenWidget");
var Types_1 = require("Tokens/Types");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var RegistryElement_1 = require("./RegistryElement");
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var StylesContext_1 = require("./StylesContext");
var FilterableColorProvider_1 = require("./Styling/FilterableColorProvider");
var SlateUtils_1 = require("./Behaviours/SlateUtils");
var Styleable_1 = require("./WidgetRegistry/Utils/Styleable");
var renderElement = function (properties, value, editor, widgetManager, onChange, usingFeature, blockStore, brandStore, uploadStore, embedUrlGenerator, blockIndex, disableWidgetAdder, widgetToolbarHost) {
    var element = properties.element;
    var isRegistryComponent = !!(0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type, true);
    if (isRegistryComponent) {
        var tokensEnableState_1 = enableTokens(widgetManager, blockStore);
        return (react_1.default.createElement(DIProvider_1.default, { container: function () {
                var container = new inversify_1.Container({ skipBaseClassChecks: true });
                container.bind("tokensEnableState").toConstantValue(tokensEnableState_1);
                return container;
            } },
            react_1.default.createElement(RegistryElement_1.RegistryElement, { properties: properties })));
    }
    switch (element.type) {
        case EditorTypes_1.InlineType.Link:
            return (react_1.default.createElement(RenderLinkWidget, { properties: properties, widgetManager: widgetManager, usingFeature: usingFeature, blockStore: blockStore, brandStore: brandStore, editor: editor, widgetToolbarHost: widgetToolbarHost }));
        case EditorTypes_1.InlineType.LineBreak:
            return renderLineBreak(properties);
        case EditorTypes_1.InlineType.TokenWidget:
            return renderTokenWidget(properties, widgetManager, editor);
        default:
            throw new Error("Unrecognised node type provided: ".concat(element.type));
    }
    return null;
};
exports.default = renderElement;
var RenderLinkWidget = function (_a) {
    var _b = _a.properties, attributes = _b.attributes, children = _b.children, element = _b.element, widgetManager = _a.widgetManager, usingFeature = _a.usingFeature, blockStore = _a.blockStore, brandStore = _a.brandStore, editor = _a.editor, widgetToolbarHost = _a.widgetToolbarHost;
    var computeForegroundColor = (0, StylesContext_1.useStylesContext)().computeForegroundColor;
    var stylePermissionsStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    var pathToWidget = (0, SlateUtils_1.findPath)(editor, element);
    var contextualStylesAllowed = (0, Styleable_1.canAccessContextualStyles)(usingFeature, editor, stylePermissionsStore, pathToWidget);
    return (react_1.default.createElement(LinkWidget_1.default, { href: element.data.href, focus: !!element.data.focus, widgetManager: widgetManager, element: element, usingFeature: usingFeature, blockStore: blockStore, brandStore: brandStore, contextualStylesAllowed: contextualStylesAllowed, attributes: attributes, toolbarHost: widgetToolbarHost, computeLinkColor: computeForegroundColor, colorProvider: colorProvider }, children));
};
var renderTokenWidget = function (_a, widgetManager, editor) {
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    return (react_1.default.createElement(TokenWidget_1.TokenWidget, { attributes: attributes, widgetManager: widgetManager, element: element, editor: editor }, children));
};
var renderLineBreak = function (renderElementProps) {
    return (react_1.default.createElement("span", __assign({}, renderElementProps.attributes),
        renderElementProps.children,
        react_1.default.createElement("br", null)));
};
var enableTokens = function (widgetManager, blockStore) {
    if (widgetManager.isInTemplate()) {
        return Types_1.TokensEnableState.EnabledWithAllInteractions;
    }
    if (blockStore.isSavedBlock) {
        return Types_1.TokensEnableState.EnabledWithoutDragAndDrop;
    }
    return Types_1.TokensEnableState.Disabled;
};
